
var ws = null

if (typeof WebSocket !== 'undefined') {
  ws = WebSocket
} else if (typeof MozWebSocket !== 'undefined') {
  ws = MozWebSocket
} else if (typeof window !== 'undefined') {
  ws = window.WebSocket || window.MozWebSocket
}

module.exports = ws



//////////////////
// WEBPACK FOOTER
// /Users/alextaxiera/source/farmhand-server/client/dashboard/~/websocket-stream/ws-fallback.js
// module id = ../../../dashboard/node_modules/websocket-stream/ws-fallback.js
// module chunks = 1